import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-advice',
  imports: [],
  templateUrl: './legal-advice.html',
  styleUrl: './legal-advice.less'
})
export class LegalAdvice {

}
